// extracted by mini-css-extract-plugin
module.exports = {"root":"FilterTable_root__3rpwE"};